import { render } from "./FlotasView.vue?vue&type=template&id=e626d82c&scoped=true"
import script from "./FlotasView.vue?vue&type=script&lang=js"
export * from "./FlotasView.vue?vue&type=script&lang=js"

import "./FlotasView.vue?vue&type=style&index=0&id=e626d82c&scoped=true&lang=css"

import exportComponent from "D:\\WGitHub\\Kubber\\kubber\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e626d82c"]])

export default __exports__